<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="modalXml = true"
        >
          <v-icon left> mdi-plus </v-icon>
          XML 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ customBoardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:item.create_at="{ item }">
          {{ item.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
        </template>

        <template v-slot:item.modify="{ item }">
          <a
            href=""
            @click.prevent="modifyPopup(item)"
            style="color: transparent"
          >
            <v-icon color="#fecd00">mdi-cog-outline</v-icon>
          </a>
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 XML이 없습니다. 우측상단 코스등록 버튼을 클릭후 코스를
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>

    <!-- modalCourse -->
    <v-dialog
      persistent
      v-model="modalXml"
      width="700"
      content-class="popup-wrap-1"
    >
      <div class="pa-9">
        <p class="title-type-4">3D배너_XML 관리</p>
        <v-form ref="form">
          <div class="form-row-1 mt-6">
            <p class="label">
              이름
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalXmlName"
                :rules="xmlRules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1">
            <p class="label">
              CC_ID
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalXmlCCID"
                :rules="xmlRules"
                solo
              ></v-text-field>
            </div>
          </div>
          <div class="form-row-1 d-block">
            <p class="label">
              XML값
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-textarea
                solo
                placeholder="글자 제한수 없습니다. 복사 붙여넣기 시 스페이스 확인하세요."
                class="input-custom-2"
                height="280px"
                v-model="modalXmlValue"
                :rules="rulesXml"
              ></v-textarea>
            </div>
          </div>
        </v-form>

        <div class="d-flex justify-end mt-6">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-2"
            @click.stop="modalXmlCancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click.prevent="registerXml"
            :disabled="!modalXmlCCID || !modalXmlName || !modalXmlValue"
          >
            저장
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //modalCourse -->

    <SystemAlert v-model="showSystemAlert" :persistent="true">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import {
  optionsList,
  optionsItemList,
  createOptionsItemList,
  updateOptionsItemList,
} from '@/api/options';

import {
  xmlList,
  detailXml,
  createXml,
  updateXml,
  deleteXml,
} from '@/api/ingame';

import SystemAlert from '~@/modal/SystemAlert';
import MediaHeader from '@/views/media/header';

export default {
  components: { MediaHeader, SystemAlert },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '10%', sortable: false },
      { text: '이름', value: 'name', width: '20%', sortable: false },
      { text: 'CC_ID', value: 'cc_id', width: '20%', sortable: false },
      { text: '등록일', value: 'create_at', width: '20%', sortable: false },
      {
        text: '등록 관리자',
        value: 'creator.manager_name',
        width: '20%',
        sortable: false,
      },
      { text: '관리', value: 'modify', width: '10%', sortable: false },
    ],
    boardLists: [],

    modifyXml: false,
    modifyXmlCCID: null,
    modifyXmlName: null,
    modifyXmlValue: '',

    modalXml: false,
    modalXmlCCID: '',
    modalXmlName: '',
    modalXmlValue: '',
    rules: [
      v => !!v || '필수 항목 입니다!',
      v => (v && v.length <= 20) || '최대 20자까지 입력해주세요.',
    ],
    xmlRules: [
      v => !!v || '필수 항목 입니다!',
      v =>
        (v && /^[a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '영문, 숫자만 입력 가능합니다.',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    rulesXml: [v => !!v || '필수 항목 입니다!'],
    resultType: '',
    logResult: '',
    showSystemAlert: false,
    xmlId: null,
  }),
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
        item.modify = '수정';
      });
      return this.boardLists;
    },
  },
  methods: {
    async getListXml() {
      try {
        const id = this.xmlId;
        const { data } = await xmlList(id);
        const getListXml = data.list;
        this.boardLists = getListXml;
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    async registerXml() {
      bus.$emit('start:spinner');
      try {
        const xmlData = {
          name: this.modalXmlName.trim(),
          cc_id: this.modalXmlCCID.trim(),
          xml_base64: btoa(this.modalXmlValue),
        };
        const id = this.xmlId;
        const { data } = this.modifyXml
          ? await updateXml(id, xmlData)
          : await createXml(xmlData);

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = `XML이 ${
            this.modifyXml ? '수정' : '등록'
          } 되었습니다.`;
          this.modifyXml = false;
        }
      } catch (error) {
        bus.$emit('end:spinner');
        const { data } = error.response;
        this.resultType = data.result;
        this.$refs.form.reset();
        this.modifyXml = false;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 이름이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      }
    },
    async getDetailXml(id) {
      try {
        const { data } = await detailXml(id);
        this.modalXmlValue = atob(data.row.xml_base64);
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      this.$refs.form.reset();
      if (type === 'success') {
        bus.$emit('start:spinner');
        this.modalXml = false;
        this.getListXml();
      }
    },
    modifyPopup(item) {
      this.modalXml = true;
      this.modifyXml = true;

      this.getDetailXml(item.id);

      this.xmlId = item.id;
      this.modalXmlName = item.name;
      this.modalXmlCCID = item.cc_id;
    },
    modalXmlCancel() {
      this.$refs.form.reset();
      this.modifyXmlCCID = null;
      this.modifyXml = false;
      this.modifyXmlValue = false;
      this.modalXml = false;
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getListXml();
  },
};
</script>
